import { useState, useCallback } from "react";

export const useConfirmation = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    title: "",
    message: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    confirmButtonColor: "primary",
    resolve: null,
  });

  const confirm = useCallback(({ title, message, confirmText = "Confirm", cancelText = "Cancel", confirmButtonColor = "primary" }) => {
    return new Promise((resolve) => {
      setDialogState({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        confirmButtonColor,
        resolve,
      });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    dialogState.resolve?.(true);
    setDialogState((prev) => ({ ...prev, open: false }));
  }, [dialogState]);

  const handleCancel = useCallback(() => {
    dialogState.resolve?.(false);
    setDialogState((prev) => ({ ...prev, open: false }));
  }, [dialogState]);

  const dialogProps = {
    open: dialogState.open,
    title: dialogState.title,
    message: dialogState.message,
    confirmText: dialogState.confirmText,
    cancelText: dialogState.cancelText,
    confirmButtonColor: dialogState.confirmButtonColor,
    onConfirm: handleConfirm,
    onClose: handleCancel,
  };

  return { confirm, dialogProps };
};
